/* src/app/admin-dashboard/membership-v2/membership-v2.component.css */
.v2-page {
  padding: 16px 20px;
}
.v2-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 8px;
}
.v2-head h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.v2-sub {
  color: #888;
  font-size: 13px;
}
.v2-tabs {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.v2-tab-body {
  padding: 16px;
}
.v2-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.v2-spacer {
  flex: 1 1 auto;
}
.v2-search {
  width: 320px;
  max-width: 100%;
}
.v2-search .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.v2-toolbar button mat-icon {
  margin-right: 4px;
  vertical-align: middle;
}
.v2-inline-spin {
  margin-left: 4px;
}
.v2-note {
  font-size: 13px;
  color: #666;
  margin: 0;
}
.v2-table-wrap {
  overflow-x: auto;
  border-top: 1px solid #f0f0f0;
}
.v2-mat-table {
  width: 100%;
}
.v2-mat-table th {
  color: #666;
  font-weight: 600;
}
.v2-systems-cell {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v2-empty {
  color: #999;
  text-align: center;
  font-style: italic;
  padding: 24px;
}
.v2-pill {
  border: none;
  border-radius: 12px;
  padding: 3px 12px;
  font-size: 12px;
  cursor: pointer;
  background: #eee;
  color: #777;
}
.v2-pill.on {
  background: #e6f4ea;
  color: #1e7e34;
}
.v2-plain-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.v2-plain-table th,
.v2-plain-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
}
.v2-plain-table th {
  color: #666;
  font-weight: 600;
}
.v2-invoice-total td {
  font-weight: 700;
  border-top: 2px solid #ddd;
}
.v2-divider {
  border: none;
  border-top: 1px solid #eee;
  margin: 24px 0 16px;
}
.v2-subhead {
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 4px;
  color: #333;
}
.v2-recon-toolbar {
  margin-top: 10px;
}
.v2-error {
  color: #c0392b;
  font-style: normal;
  text-align: left;
  padding: 8px 0;
}
.v2-file-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  color: #444;
  background: #fafafa;
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v2-file-btn:hover {
  background: #f0f0f0;
}
.v2-file-btn mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.v2-recon-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 0;
}
.v2-chip {
  border-radius: 12px;
  padding: 3px 12px;
  font-size: 12px;
  font-weight: 600;
  background: #eef1f4;
  color: #555;
}
.v2-chip-ok {
  background: #e6f4ea;
  color: #1e7e34;
}
.v2-chip-warn {
  background: #fdecea;
  color: #c0392b;
}
.v2-flag-cell {
  color: #c0392b;
  font-weight: 600;
}
.v2-reason {
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  background: #fdecea;
  color: #c0392b;
}
.v2-reason-partial-refund {
  background: #fff4e5;
  color: #b26a00;
}
.v2-recon-diag {
  padding-top: 0;
  opacity: 0.95;
}
.v2-recon-diag .v2-chip {
  background: #f4f6f8;
  color: #667;
}
.v2-map-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #555;
  cursor: pointer;
}
.v2-map-table td {
  vertical-align: middle;
}
.v2-row-unassigned td {
  background: #fff8f2;
}
.v2-map-select-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.v2-map-select {
  min-width: 220px;
}
.v2-map-saving {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: #b26a00;
  animation: v2-spin 1.2s linear infinite;
}
@keyframes v2-spin {
  to {
    transform: rotate(360deg);
  }
}
.v2-map-search {
  width: 360px;
  max-width: 100%;
}
.v2-map-search .mat-mdc-form-field-icon-prefix {
  padding-right: 6px;
  color: #888;
}
.v2-select-search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}
.v2-select-search mat-icon {
  color: #888;
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.v2-select-search input {
  border: none;
  outline: none;
  flex: 1 1 auto;
  font-size: 14px;
  background: transparent;
}
.v2-select-empty {
  padding: 8px 14px;
  color: #888;
  font-size: 13px;
}
/*# sourceMappingURL=membership-v2.component.css.map */
